import TagManager from "react-gtm-module";
import {
  CartItemTypes,
  ICartItemType,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import {
  GtagActionField,
  IGTagUserData,
} from "./useEventTrackers/helpers/interfaces";
import { toSHA256Hex } from "@/utils/functions/toSHA256Hex";

export enum StandardPixelEvents {
  AddPaymentInfo = "AddPaymentInfo",
  AddToCart = "AddToCart",
  AddToWishlist = "AddToWishlist",
  CompleteRegistration = "CompleteRegistration",
  Contact = "Contact",
  CustomizeProduct = "CustomizeProduct",
  Donate = "Donate",
  FindLocation = "FindLocation",
  InitiateCheckout = "InitiateCheckout",
  Lead = "Lead",
  PageView = "PageView",
  Purchase = "Purchase",
  Schedule = "Schedule",
  Search = "Search",
  StartTrial = "StartTrial",
  SubmitApplication = "SubmitApplication",
  Subscribe = "Subscribe",
  ViewContent = "ViewContent",
}
//! we don't need it any more because if we need to collect custom Google Analytics
//! envent we should to connect it with Google Tag Manager
// export function useTrackEvent() {
//   const isClient = useIsClient();
//   const GA_INITIALIZED =
//     Object.keys((window as any).google_tag_manager || []).filter((e) => {
//       return e.substring(0, 2) == "G-";
//     }).length > 0;
//   const trackEvent = (event: any, data: any = null) => {
//     if (isClient) {
//       if (GA_INITIALIZED) {
//         (window as any)?.GA_MANAGER?.event({
//           category: "ecommerce",
//           action: event,
//           label: data?.content_name,
//           value: data?.content_ids ? data.content_ids[0] : data?.value,
//         });
//       }
//     }
//   };
//   return trackEvent;
// }
const getItemCategories = (categories_names: string[]) =>
  categories_names.length > 0
    ? categories_names.reduce(
        (prev, current, idx) => ({
          ...prev,
          [`item_category${idx === 0 ? "" : `_${idx}`}`]: current,
        }),
        {},
      )
    : {};
export const Gtag = (
  event: any,
  items: ICartItemType[],
  actionField: GtagActionField,
  affiliation: string,
  getPriceString: (price: number) => string,
  currency: string,
) => {
  const itemsToPost = [
    ...items?.map((item) => ({
      item_id:
        item.type === CartItemTypes.product
          ? item?.others?.parent_id ?? item.inner_id
          : item.inner_id,
      item_name: item?.parent?.name ?? item.name,
      item_sku: item?.parent?.sku ?? "",
      affiliation: affiliation,
      coupon: actionField.coupon,
      discount: +getPriceString(item.discount),
      index: item.id,
      price: +getPriceString(item.price),
      quantity: item.quantity,
      item_variant: (item.type === CartItemTypes.product
        ? item?.others?.attrs_values.map((attr) => attr.name)
        : []
      ).join(","),
      ...getItemCategories(item?.categories_names ?? []),
    })),
  ];
  const actionFieldToPost = {
    ...actionField,
    value: +getPriceString(actionField?.value!),
    discount: +getPriceString(actionField?.discount!),
    shipping: +getPriceString(actionField?.shipping!),
    tax: +getPriceString(actionField?.tax!),
    currency: currency,
  };
  const GTM_INITIALIZED =
    Object.keys((window as any).google_tag_manager || []).filter((e) => {
      return e.substring(0, 4).includes("GTM-") || e.includes("debugGroupId");
    }).length > 0;
  if (GTM_INITIALIZED) {
    TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear the previous ecommerce object.
    TagManager.dataLayer({
      dataLayer: {
        event: event,
        ecommerce: {
          ...actionFieldToPost,
          items: [...itemsToPost],
        },
      },
    });
  }
};

export const GTagUserLoginEvent = (
  isLogedin: boolean,
  userdata: IGTagUserData,
) => {
  const GTM_INITIALIZED =
    Object.keys((window as any).google_tag_manager || []).filter((e) => {
      return e.substring(0, 4).includes("GTM-");
    }).length > 0;
  if (GTM_INITIALIZED) {
    TagManager.dataLayer({
      dataLayer: {
        event: "userLogin",
        user_login: isLogedin,
        userdata: {
          ...userdata,
        },
      },
    });
  }
};
export const GTagSearchEvent = (
  search: string,
  search_result: "found" | "not found",
) => {
  const GTM_INITIALIZED =
    Object.keys((window as any).google_tag_manager || []).filter((e) => {
      return e.substring(0, 4).includes("GTM-");
    }).length > 0;
  if (GTM_INITIALIZED) {
    TagManager.dataLayer({
      dataLayer: {
        event: "search_event",
        search: search,
        search_result: search_result,
      },
    });
  }
};

export const GTagMaillistConversionEvent = (email: string) => {
  const GTM_INITIALIZED =
    Object.keys((window as any).google_tag_manager || []).filter((e) => {
      return e.substring(0, 4).includes("GTM-");
    }).length > 0;
  if (GTM_INITIALIZED) {
    TagManager.dataLayer({
      dataLayer: {
        event: "maillist_conversion",
        email: email,
        email_hash: email ? toSHA256Hex(email) : "",
      },
    });
  }
};
